import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
import { ElMessage, ElNotification, ElMessageBox } from 'element-plus'
import { Grade } from '@/types/gradeInterface'
const baseURL = process.env.VUE_APP_API_BASE_URL;
export function getGradeList() {
    openLoading()
    const data = new FormData();
    const headers = {
        'token': localStorage.getItem("token")
    }
    return new Promise((resolve, reject) => {
        axios.post(baseURL + "/userApi/getGradeList", data, { timeout: 5000, headers: headers })
            .then(res => {
                fullscreenLoading.close()
                if (res.data.code == -1) {
                    ElMessage.error('您没有登录')
                    setTimeout(() => {
                        location.href = "/Login"
                    }, 1000);
                }
                resolve(res.data);

            })
            .catch(err => {
                fullscreenLoading.close()
                console.log(err)
                resolve(err);
                ElMessage.error('请求失败：' + err.message)
            })
    })
}
export function getIncludesList(pageNum: any, page: any) {
    openLoading()
    const data = new FormData();
    data.append("pageNum", pageNum)
    data.append("page", page)
    const headers = {
        'token': localStorage.getItem("token")
    }
    return new Promise((resolve, reject) => {
        axios.post(baseURL + "/xiaochu/getIncludes", data, { timeout: 5000, headers: headers })
            .then(res => {
                fullscreenLoading.close()
                resolve(res.data);
            })
            .catch(err => {
                fullscreenLoading.close()
                console.log(err)
                resolve(err);
                ElMessage.error('请求失败：' + err.message)
            })
    })
}
export function getEmpowerIncludesList() {
    openLoading()
    const data = new FormData();
    data.append("act", 'getEmpowerIncludesList')
    const headers = {
        'token': localStorage.getItem("token")
    }
    return new Promise((resolve, reject) => {
        axios.post(baseURL + "/userApi/getIncludesAgent", data, { timeout: 5000, headers: headers })
            .then(res => {
                fullscreenLoading.close()
                resolve(res.data);
            })
            .catch(err => {
                fullscreenLoading.close()
                ElMessage.error('获取代理插件列表失败：' + err.message)
            })

    })
}
export function getUserInfo() {
    openLoading()
    const headers = {
        'token': localStorage.getItem("token")
    }
    return new Promise((resolve, reject) => {
        axios.get(baseURL + "/userApi/getUserInfo", { timeout: 5000, headers: headers })
            .then(res => {
                fullscreenLoading.close()
                resolve(res.data);
            })
            .catch(err => {
                fullscreenLoading.close()
                resolve(err);
                ElMessage.error('获取用户信息失败：' + err.message)
            })
    })
}
export const rules = {
    email: [
        { required: true, message: '请输入邮箱', trigger: ['change'] },
        { type: 'email', message: '请输入正确的邮箱格式', trigger: ['change'] },
    ],
    host: [
        { required: true, message: '请输入域名', trigger: ['change'] },
        { validator: validateHost, trigger: ['blur', 'change'] },
    ],
}
export function validateHost(rule: any, value: any, callback: any) {
    const regExp = /[!@#$%^&*()_+\-=[\]{};':"\\|,<>/?]+/
    if (regExp.test(value)) {
        callback(new Error('不要带/等字符，标准格式：www.baidu.com'));
    } else {
        callback();
    }
}
export function isNull(str: any) {
    if (typeof str == 'number' || typeof str == 'boolean') {
        return false
    }
    if (str == undefined || str.trim() == "" || str == null) {
        return true
    }
    return false
}
export function fallbackCopyTextToClipboard(text: any) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();
    try {
        const successful = document.execCommand('copy');
        if (successful) {
            ElMessage.success("一键复制成功")
        } else {
            ElMessage.error("复制失败，请手动复制");
        }
    } catch (err) {
        ElMessage.error("复制失败，请手动复制");
    }

    document.body.removeChild(textArea);
}
export function copyFun(text: any) {
    if (isNull(text)) {
        ElMessage.error('待复制值为空')
        return
    } navigator.clipboard.writeText(text)
        .then(() => {
            ElMessage.success("复制成功");
        })
        .catch((err) => {
            fallbackCopyTextToClipboard(text)
        });
}
export interface Meal {
    [key: string]: {
        [key: string]: any
    }
}
export interface TimePrice {
    time_unit: string;
    price: any;
    meal_id: number;
}
export interface GradeConf {
    grade: number;
    grade_name: string;
}

export interface PriceMeal {
    grade_conf: GradeConf;
    time_price: TimePrice[];
}
export interface VersionLog {
    id: number;
    version_code: number;
    update_url: string;
    version_desc: string;
    deliver_date: string;
}
export interface JsonData {
    [key: string]: any
}
export const getEmpower = (page: number, pageSize: number): Promise<EmpowerResponse> => {
    openLoading()
    const data = new FormData()
    const headers = {
        'token': localStorage.getItem('token')
    }
    data.append("act", "getEmpower")
    data.append("pageSize", String(pageSize))
    data.append("page", String(page))
    return new Promise((resolve, reject) => {
        axios.post(baseURL + "/userApi/getEmpower", data, { timeout: 5000, headers: headers })
            .then(res => {
                fullscreenLoading.close()
                resolve(res.data);
            })
            .catch(err => {
                fullscreenLoading.close()
                console.log(err)
            })
    })
}
export const getLowerEmpower = (uid: number, page: number, pageSize: number): Promise<EmpowerResponse> => {
    openLoading()
    const data = new FormData()
    const headers = {
        'token': localStorage.getItem('token')
    }
    data.append("lower_uid", String(uid))
    data.append("pageSize", String(pageSize))
    data.append("page", String(page))
    return new Promise((resolve, reject) => {
        axios.post(baseURL + "/userApi/getEmpower", data, { timeout: 5000, headers: headers })
            .then(res => {
                fullscreenLoading.close()
                resolve(res.data);
            })
            .catch(err => {
                fullscreenLoading.close()
                console.log(err)
            })
    })
}
export interface EmpowerResponse {
    code: number;
    total_empower: number;
    data: any;
}
export function isLogin(res: any) {
    if (res.data.code == -1) {
        ElMessage.error(res.data.msg)
        setTimeout(() => {
            location.href = "/login"
        }, 1000);
    }
}
export function compareDates(a: any, b: any) {
    // Support both { date: "2024-01-01", log: {...} } and { "2024-01-01": {...} } structures
    const dateKeyA = a.date || Object.keys(a)[0];
    const dateKeyB = b.date || Object.keys(b)[0];
    const dateA = new Date(dateKeyA);
    const dateB = new Date(dateKeyB);
    return dateA.getTime() - dateB.getTime();
}
export function openBox(apiUrl: string) {
    ElMessageBox.confirm(
        '您还不是开发者,您想要成为开发者吗',
        'sorry',
        {
            confirmButtonText: '成为开发者',
            cancelButtonText: '关闭',
            type: 'warning',
        }
    )
        .then(() => {
            location.href = apiUrl;
        }).catch(() => { 
            console.log("");
            
        })
}
